import React, { useEffect, useState, useRef } from 'react';
import ProfileContainer from "../components/ProfileContainer";
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

const formatFullCity = location => {
    // if (location.country === 'US') {
    //     const lastCommaIndex = location.full.lastIndexOf(',');
    //     if (lastCommaIndex === -1) {
    //         // No comma found, return the original string
    //         return location.full;
    //     } else {
    //         // Return the substring from the beginning up to the last comma
    //         return location.full.substring(0, lastCommaIndex);
    //     }
    // }

    return location.full || `${location.city}${!!location.state && `, ${location.state}`}`;
}

const AgencyProfileLocations = ({ items }) => {
    const [isOpen, setIsOpen] = useState(true);

    // items = [...items, ...additionalCoordsForTesting];

    return (
        <div id="locations" className="pt-2 pb-8">
            <ProfileContainer>
                <div>
                    <h4 className="textbold text-lg pb-6">Our {TB.pluralize('Location', items.length)}</h4>

                    {!items.length && (
                        <div className="py-8 text-center">
                            <p className="text-base">No Locations Available</p>
                        </div>
                    )}

                    {!!items.length && (
                        <>
                            <div className="flex pb-4">

                                <div className="w-full">
                                    <p className="text-lg">Main HQ:</p>
                                    <p>{formatFullCity(items[0])}</p>
                                </div>

                                {items.length > 1 && (
                                    <div className="w-full">
                                        <p className="text-lg">Additional locations:</p>
                                        {items.map((item, ind) => {
                                            if (ind === 0) return null;
                                            return (
                                                <p key={item.id}>{formatFullCity(item)}</p>
                                            )
                                        })}
                                    </div>
                                )}
                            </div>

                            <MapboxMap locations={items} />
                        </>
                    )}
                </div>
            </ProfileContainer>
        </div>
    )
}

export default AgencyProfileLocations;


const MapboxMap = ({ locations }) => {
    const mapContainerRef = useRef();
    const mapRef = useRef();

    console.log('center', locations[0]?.longitude, locations[0]?.latitude)

    useEffect(() => {
        mapboxgl.accessToken = 'pk.eyJ1Ijoia2VpdGh3cmlwcGxlIiwiYSI6ImNsNTMxN2d4MTAxbTYzcW1mZmhnaW96eXkifQ.6LoANVf0-IcjzWSrZSPt3A';

        mapRef.current = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/standard',
            zoom: 6,
            center: [locations[0]?.longitude, locations[0]?.latitude],
            interactive: false, // Disables all user interactions
            // Disable all interactions
            scrollZoom: false,
            boxZoom: false,
            dragRotate: false,
            dragPan: true,
            keyboard: false,
            doubleClickZoom: false,
            // touchZoomRotate: {
            //     around: 'center' // Zoom around center, not touch point
            // }
        });


        const getBounds = locations.reduce((acc, location) => {
            let markerParams = {color: TB.config('color.secondary')}
            // create marker
            if (location.is_default) {
                const iconMarker = document.createElement('div');
                iconMarker.innerHTML = `<i class="fas fa-star text-xl text-danger" style="font-size: 30px"></i>`;

                markerParams = iconMarker;
            }
            new mapboxgl.Marker(markerParams)
                .setLngLat([location.longitude, location.latitude])
                .addTo(mapRef.current);

            // get all lats / longs
            const long = [...acc.long, location.longitude];
            const lat = [...acc.lat, location.latitude];

            // set fitBounds bounds coordinates
            const bounds = [
                [Math.min(...long), Math.min(...lat)], // Southwest corner
                [Math.max(...long), Math.max(...lat)]  // Northeast corner
            ];

            return { long, lat, bounds }
        }, { long: [], lat: [], bounds: [] })

        if (locations.length > 1) {
            mapRef.current.fitBounds(getBounds.bounds, {
                padding: 50,
            });
        }

        // return () => mapRef.current.colorremove();
    }, []);

    return (
        <div className="h-[500px]">
            <div id="map" ref={mapContainerRef} style={{ height: '100%' }} />
        </div>
    )
};